module.exports = __webpack_public_path__ + "img/icone-trabalhos.739f126b.svg";